/* eslint-disable react/prop-types */

export const ColumnFilterBoolean = ( { column } ) => {
	
	const {filterValue, setFilter} = column
	return(
		<div>
		
			<input className="form-control input-search"
                placeholder="true / false"
				value={filterValue || ''}  onChange={e => setFilter(e.target.value)} />
		</div>
	)
} 